import { Box } from '@mui/material'
import { tableSx, tableWrapSx } from './markdownSx'
import { withCitations } from './withCitations'

/**
 * Table overrides — defect 2 in the plan: the real agent path had no table
 * branch at all, so every markdown table rendered as literal pipes.
 *
 * Deviation from the plan, deliberate: it says to wire the existing
 * `TableCellMarkdown` to the `td` renderer, but that component calls
 * `stripMarkdownFormatting` — it *removes* markdown rather than rendering it.
 * Using it here would strip bold, code and citation markers out of every cell,
 * which is worse than what react-markdown already produces. Cells therefore go
 * through the same citation-aware pipeline as the rest of the document.
 *
 * `scope` on header cells is what lets a screen reader associate a data cell
 * with its column (P4.3).
 */
export function tableComponents(citations) {
  const cite = (children, key) => withCitations(children, citations, key)

  return {
    table: ({ children }) => (
      <Box sx={tableWrapSx}>
        <Box component="table" sx={tableSx}>{children}</Box>
      </Box>
    ),
    thead: ({ children }) => <Box component="thead">{children}</Box>,
    tbody: ({ children }) => <Box component="tbody">{children}</Box>,
    tr: ({ children }) => <Box component="tr">{children}</Box>,
    // remark-gfm reports column alignment as an inline `style`. Forwarded via
    // `sx` rather than `style` so it goes through the same styling system as
    // everything else (and satisfies the house no-inline-style rule).
    th: ({ children, style }) => (
      <Box component="th" scope="col" sx={alignSx(style)}>{cite(children, 'th')}</Box>
    ),
    td: ({ children, style }) => (
      <Box component="td" sx={alignSx(style)}>{cite(children, 'td')}</Box>
    ),
  }
}

function alignSx(style) {
  return style?.textAlign ? { textAlign: style.textAlign } : undefined
}
